import { Component, Input, OnInit } from '@angular/core';
import { RoadmapSection } from 'src/app/model/shared/roadmap-section';

@Component({
  selector: 'app-roadmap-section',
  templateUrl: './roadmap-section.component.html',
  styleUrls: ['./roadmap-section.component.scss']
})
export class RoadmapSectionComponent implements OnInit {
  @Input() roadmapSections: RoadmapSection[] = [];
  constructor() {}

  ngOnInit(): void {}
}
